import { NgModule } from '@angular/core';
import { ErrorHandler } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';

import { AppRoutingModule } from './app.routing';
import { AppErrorHandler } from './app.errorhandler';
import { AppComponent } from './app.component';
import { StorytellingCommonModule } from '@common/storytelling-common.module';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        RouterModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        StorytellingCommonModule,
        BrowserModule
    ],
    providers: [
        {
            provide: ErrorHandler,
            useClass: AppErrorHandler
        },
        Title
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
